module.exports = __webpack_public_path__ + "static/media/App.42f81896.sass";


//////////////////
// WEBPACK FOOTER
// ./src/App.sass
// module id = 419
// module chunks = 1